import { message } from 'antd';
import api from './api';

export const listaUsuarios = async params => {
  const { registerNumber, pageNumber } = params;
  try {
    const { data } = await api.get(
      `/usuario/list?page=${pageNumber}&numeroRegistros=${registerNumber}`
    );
    return { data };
  } catch (error) {
    return { error };
  }
};

export const listaClientes = async params => {
  const { registerNumber, pageNumber } = params;
  try {
    const { data } = await api.get(
      `/cliente/list?page=${pageNumber}&numeroRegistros=${registerNumber}`
    );
    return { data };
  } catch (error) {
    return { error };
  }
};

export const listaGrupos = async () => {
  try {
    const { data } = await api.get('/GrupoUsuario/list');
    return { data };
  } catch (error) {
    return { error };
  }
};

export const getEditarUsuario = async params => {
  const { id } = params;
  try {
    const { data } = await api.get(`Usuario/${id}/grupos`);
    return { data };
  } catch (error) {
    return { error };
  }
};

export const putEditarUsuario = async params => {
  const { payload } = params;
  try {
    const { data } = await api.put('/usuario', payload);
    message.success(
      `Usuário ${payload.nome} atualizado com sucesso`
    );
    return { data };
  } catch (error) {
    if (error.response) {
      message.error(error.response.data.detail);
    } else {
      message.error('Erro ao criar um novo usuário.');
    }
    return { error };
  }
};

export const postEditarUsuario = async params => {
  const { payload } = params;
  try {
    const { data } = await api.post('/usuario', payload);
    message.success('Novo usuário cadastrado com sucesso');
    return { data };
  } catch (error) {
    if (error.response) {
      message.error(error.response.data.detail);
    } else {
      message.error('Erro ao criar um novo usuário.');
    }
    return { error };
  }
};

export const putOnPost = async params => {
  const { id, idGroupForNewCustomer } = params;
  try {
    const { data } = await api.put(
      `/Usuario/${id}/grupos/${
        idGroupForNewCustomer
      }`
    );
    return { data };
  } catch (error) {
    return { error };
  }
};

export const putChangeOption = async params => {
  const { id, setPosition } = params;
  try {
    const { data } = await api.put(`/Usuario/${id}/groups/${setPosition}`);
    return { data };
  } catch (error) {
    return { error };
  }
};

export const deleteOptionGroup = async params => {
  const { id, e } = params;
  try {
    await api.delete(`/Usuario/${id}/groups/${e}`);
    return message.success('Grupo de usuário removido com sucesso');
  } catch (error) {
    return message.error('erro ao criar usuário');
  }
};
